import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {delCmnctCctvImg, delCmnctGtwyImg, getGWInfo, postGW, putGW} from "../../api/apiClient";
import ComboFclty from "../../components/inputs/ComboFclty";
import Swal from "sweetalert2";
import Moment from "moment";
import DatePicker from "react-date-picker";

const GwDetail = ({
                    propGwID = null,
                    setShow,
                    updateList
                  }) => {

  /* 게이트웨이 data */
  const [gatewayData, setGatewayData] = useState({});
  const [type, setType] = useState("post");

  useEffect(() => {
    if (propGwID != null) {
      setType("put");
    }
  }, [propGwID]);

  useEffect(() => {
    updateLayerInfo();
  }, []);

  useEffect(() => {
    console.log(gatewayData);
  }, [gatewayData]);

  const updateLayerInfo = () => {
    if (propGwID != null) {
      getGWInfo(propGwID).then(response => {
        // console.log(response.data.data);
        setGatewayData(response.data.data);
      });
    }
  };

  const onChangeGtwyId = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      gtwy_id: e.target.value
    }));
  };

  const onChangeSid = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      sid: e.target.value
    }));
  };

  const onChangeIp1Addr = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      ip1_addr: e.target.value
    }));
  };

  const onChangeIp2Addr = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      ip2_addr: e.target.value
    }));
  };

  const onChangeL2IpAddr = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      l2_ip_addr: e.target.value
    }));
  };

  const onChangeCctvPoleNo = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      cctv_pole_no: e.target.value
    }));
  };

  const onChangeFcltyCd = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      fclty_no: e.target.value
    }));
  };

  const onChangeLa = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      la: e.target.value
    }));
  };

  const onChangeLo = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      lo: e.target.value
    }));
  };

  const onChangeMkr = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      mkr: e.target.value
    }));
  };

  const onChangeModl = (e) => {
    setGatewayData(prevState => ({
      ...prevState,
      modl: e.target.value
    }));
  };

  const onChangeCrtDtStr = (e) => {

    setGatewayData(prevState => ({
      ...prevState,
      crt_dt_str: e.target.value
    }));
  };

  const onChangeInstlDe = (date) => {
    setGatewayData(prevState => ({
      ...prevState,
      // instl_de: e.target.value
      instl_de: Moment(date).format('YYYY-MM-DD')
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // console.log(type);
    // console.log(gatewayData);

    if (!gatewayData.gtwy_id) {
      Swal.fire(
          '게이트웨이 ID는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.ip1_addr) {
      Swal.fire(
          'GW IP1는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.ip2_addr) {
      Swal.fire(
          'GW IP2는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.l2_ip_addr) {
      Swal.fire(
          'L2 IP는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.cctv_pole_no) {
      Swal.fire(
          'CCTV Pole 번호는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.fclty_no) {
      Swal.fire(
          '시설명은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.la) {
      Swal.fire(
          '위도는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!gatewayData.lo) {
      Swal.fire(
          '경도는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }


    if (type === "post") {
      // API 명세서 요청 필요
      postGW(gatewayData)
          .then(res => {
            // console.log(res);
            if (res.data.status === 200) {
              setShow();
              updateList();
              // let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
            } else {
              Swal.fire(
                  res.data.message,
                  '',
                  'error'
              );
            }
          })
          .catch(err => {
            updateList();
            Swal.fire(
                err.response.data?.message,
                '',
                'error'
            );
          });
    } else if (type === "put") {
      // API 명세서 요청 필요
      putGW(gatewayData)
          .then(res => {
            // console.log(res);
            if (res.data.status === 200) {
              setShow();
              updateList();
              let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
            } else {
              Swal.fire(
                  res.data.message,
                  '',
                  'error'
              );
            }
          })
          .catch(err => {
            updateList();
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
  };

  const viewImage = () => {
    Swal.fire({
      imageUrl: 'data:image/png;base64,' + gatewayData.image_data,
      confirmButtonText: `확인`,
    })
  }

  const onDelImg = () => {
    const gtwy_no = gatewayData.gtwy_no;

    Swal.fire({
      title: `첨부된 이미지를 삭제하시겠습니까?`,
      // imageUrl: 'data:image/png;base64,' + gatewayData.image_data,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delCmnctGtwyImg(gtwy_no)
            .then((res) => {
              Swal.fire(
                  '삭제되었습니다!',
                  '',
                  'success'
              );
              setGatewayData({...gatewayData, image_data: '', image_file_nm: ''});
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
      }
    })
  };


  return (
      <Row className={"layer"}>
        <Col className={''}>
          <Row className={'info-container py-2 mx-3 justify-content-center'}>
            <Col md={11} className={'px-5'}>
              <div className={'content-container-body-item'}>
                <Form
                    className={'gateway-register-form py-3'}
                    id={'gatewayRegisterForm'}
                    onSubmit={onSubmit}
                >
                  <Row className={"justify-content-center"}>
                    <Col md={8}>
                      <Row>
                        <Col md={12}>
                          <Form.Group as={Row} controlId="formGtwyId">
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>게이트웨이 ID
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.gtwy_id || ''}
                                  value={gatewayData.gtwy_id || ''}
                                  onChange={onChangeGtwyId}
                                  readOnly={type === 'put'}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              장비시리얼 ID
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.sid || ''}
                                  value={gatewayData.sid || ''}
                                  onChange={onChangeSid}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp1Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>GW IP1
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.ip1_addr || ''}
                                  value={gatewayData.ip1_addr || ''}
                                  onChange={onChangeIp1Addr}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>GW IP2
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.ip2_addr || ''}
                                  value={gatewayData.ip2_addr || ''}
                                  onChange={onChangeIp2Addr}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='forml2IpAddr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>L2 IP
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.l2_ip_addr || ''}
                                  value={gatewayData.l2_ip_addr || ''}
                                  onChange={onChangeL2IpAddr}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formCctvPoleNo'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>CCTV Pole 번호
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.cctv_pole_no || ''}
                                  value={gatewayData.cctv_pole_no || ''}
                                  onChange={onChangeCctvPoleNo}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <ComboFclty
                              propLabelRatio={4}
                              propOnChange={onChangeFcltyCd}
                              propValue={gatewayData.fclty_no}
                              propLocation={"FIELD"}
                          />
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formLaLo'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>위도 / 경도
                            </Form.Label>
                            <Col md={8}>
                              <Row>
                                <Col md={5}>
                                  <Form.Control
                                      type='text'
                                      className={'input text-white'}
                                      // defaultValue={gatewayData.la || ''}
                                      value={gatewayData.la || ''}
                                      onChange={onChangeLa}
                                  />
                                </Col>
                                <Col md={2} className={"text-center"}>
                                  <span>/</span>
                                </Col>
                                <Col md={5}>
                                  <Form.Control
                                      type='text'
                                      className={'input text-white'}
                                      // defaultValue={gatewayData.lo || ''}
                                      value={gatewayData.lo || ''}
                                      onChange={onChangeLo}
                                  />
                                </Col>
                              </Row>
                            </Col>

                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              제조사
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.mkr || ''}
                                  value={gatewayData.mkr || ''}
                                  onChange={onChangeMkr}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              모델
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  // defaultValue={gatewayData.modl || ''}
                                  value={gatewayData.modl || ''}
                                  onChange={onChangeModl}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              설치일자
                            </Form.Label>
                            <Col md={8}>
                              {/*<Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  defaultValue={gatewayData.instl_de || ''}
                                  onChange={onChangeInstlDe}
                              />*/}
                              <DatePicker
                                  onChange={(date) => {
                                    // onChangeInfo('instl_de', Moment(date).format('YYYY-MM-DD'));
                                    onChangeInstlDe(date);
                                  }}
                                  value={gatewayData.instl_de ? new Date(gatewayData.instl_de) : ''}
                                  format={"yyyy-MM-dd"}
                                  clearIcon={null}
                                  className={"datepicker-start w-100 text-center"}
                                  calendarType={'US'}
                                  formatDay={
                                    (locale, date) => new Intl.DateTimeFormat(
                                        'en-US',
                                        {
                                          day: "numeric"
                                        }).format(date)
                                  }
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        {/*<Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              설치사진
                            </Form.Label>
                            <Col md={5}>
                              <Form.Control
                                  type='file'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    // onChangeInfo(['image_file_nm', 'filepath'],
                                    setGatewayData({
                                      ...gatewayData,
                                      filepath: e.target.files[0]
                                    })
                                    //     [e.target.value, e.target.files[0]], true);
                                  }}
                              />
                            </Col>
                            <Col md={3}>
                              <Button type={"button"}
                                      onClick={viewImage}
                                      disabled={gatewayData.image_data ? false : true}
                              >
                                보기
                              </Button>
                              <span> </span>
                              <Button type={"button"}
                                      onClick={onDelImg}>
                                삭제
                              </Button>
                            </Col>

                          </Form.Group>
                        </Col>*/}

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              설치사진
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='file'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    // onChangeInfo(['image_file_nm', 'filepath'],
                                    setGatewayData({
                                      ...gatewayData,
                                      filepath: e.target.files[0]
                                    })
                                    //     [e.target.value, e.target.files[0]], true);
                                  }}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                            </Form.Label>
                            <Col md={5}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  value={gatewayData.image_file_nm || ''}
                                  readOnly={true}
                              />
                            </Col>
                            <Col md={3}>
                              <Button type={"button"}
                                      onClick={viewImage}
                                      disabled={gatewayData.image_data ? false : true}
                              >
                                보기
                              </Button>
                              <span> </span>
                              <Button type={"button"}
                                      variant={"danger"}
                                      onClick={onDelImg}
                                      disabled={gatewayData.image_data ? false : true}
                              >
                                삭제
                              </Button>
                            </Col>
                          </Form.Group>
                        </Col>


                      </Row>
                    </Col>
                  </Row>

                  <Row className={"mt-5 my-3 justify-content-center"}>
                    <Col md={2} className={'justify-content-center text-center'}>
                      <Button onClick={onSubmit} className={'btn save-btn w-100'}>저장</Button>
                    </Col>
                    <Col md={2} className={'justify-content-center text-center'}>
                      <Button onClick={setShow} className={'btn btn-secondary w-100'}>취소</Button>
                    </Col>
                  </Row>

                </Form>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};

export default GwDetail;